import React from "react";
import { Helmet } from "react-helmet-async";

function SEOHead({
  title,
  description,
  canonical,
  ogTitle,
  ogDescription,
}) {
  const finalTitle = title
    ? `${title} | EmployPilot`
    : "EmployPilot | AI Resume Builder, Cover Letters & Career Tools";

  const finalDescription =
    description ||
    "EmployPilot helps job seekers build stronger resumes, create cover letters, prepare for interviews, and move forward with confidence.";

  const finalCanonical =
    canonical || "https://employpilot.com/";

  return (
    <Helmet>
      <title>{finalTitle}</title>

      <meta
        name="description"
        content={finalDescription}
      />

      <link
        rel="canonical"
        href={finalCanonical}
      />

      <meta
        property="og:title"
        content={ogTitle || finalTitle}
      />

      <meta
        property="og:description"
        content={ogDescription || finalDescription}
      />

      <meta
        property="og:url"
        content={finalCanonical}
      />

      <meta
        property="og:type"
        content="website"
      />

      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={ogTitle || finalTitle}
      />

      <meta
        name="twitter:description"
        content={ogDescription || finalDescription}
      />
    </Helmet>
  );
}

export default SEOHead;